import { createStore } from '@vfde-sails/core';
import roamingAdvisor from './container/RoamingAdvisor';

import './style.scss';
import { trackingMiddleware } from '@vfde-sails/tracking';

createStore({}, [trackingMiddleware]);

roamingAdvisor();
